import { httpClient } from '../funcs';
import { 
    isCustomerEntity, 
    isEntrepreneurEntity, 
    contactsEntities,
    customerAllEntities,
    entrepreneurAllEntities,
    SystemEntity 
} from './SystemEntity';

export enum SigningEventType {
    SIGN_BUTTON_CLICK = 'SIGN_BUTTON_CLICK',
    CODE_REQUEST = 'CODE_REQUEST',
    CODE_VALIDATION = 'CODE_VALIDATION',
    SIGNING_COMPLETE = 'SIGNING_COMPLETE',
    SIGNING_ERROR = 'SIGNING_ERROR'
}

export enum PerformanceEventType {
    PAGE_LOAD_METRICS = 'PAGE_LOAD_METRICS'
}

export enum PhotoProcessingEventType {
    PHOTO_PROCESSING_SUCCESS = 'PHOTO_PROCESSING_SUCCESS',
    PHOTO_PROCESSING_ERROR = 'PHOTO_PROCESSING_ERROR',
    IMAGE_COMPRESSION_ERROR = 'IMAGE_COMPRESSION_ERROR'
}

export interface SigningEventData {
    eventType: SigningEventType;
    contractId: string;
    timeFromStart?: number;
    timeFromLastEvent?: number;
    visibleSystemEntities?: string[];
    validationErrors?: string[];
    role?: string;
    isAlreadyRegisteredUser: boolean;
    errorMessage?: string;
    phoneNumber?: string;
}

export interface PerformanceEventData {
    eventType: PerformanceEventType;
    firstContentfulPaint: number;
    domInteractive: number;
    domComplete: number;
    loadTime: number;
    bundleSize: number;
    chunkLoadTime?: number;
    chunkSize?: number;
}

export interface PhotoProcessingEventData {
    eventType: PhotoProcessingEventType;
    fileInfo: {
        name: string;
        type: string;
        size: string;
        lastModified: string;
    };
    resultInfo?: {
        size: string;
        type: string;
        name: string;
    };
    processingTime: number;
    browserInfo: any;
    errorType?: string;
    errorMessage?: string;
    compressionParams?: any;
}

// Время начала загрузки страницы
const pageLoadTime = Date.now();

// Время последнего события
let lastEventTime = pageLoadTime;

function filterSystemEntitiesByRole(entities: string[] = [], role?: string): string[] {
    if (!role || !entities.length) return entities;
    
    const contactFields = contactsEntities.map(entity => entity.keyword);
    
    return entities.filter(entityKeyword => {
        // Всегда включаем контактные данные
        if (contactFields.includes(entityKeyword)) {
            return true;
        }
        
        // Фильтруем остальные поля по роли
        if (role === 'customer') {
            return customerAllEntities
                .concat(contactsEntities)
                .map(entity => entity.keyword)
                .includes(entityKeyword);
        } else if (role === 'entrepreneur') {
            return entrepreneurAllEntities
                .concat(contactsEntities)
                .map(entity => entity.keyword)
                .includes(entityKeyword);
        }
        
        return false;
    });
}

// Функция для преобразования camelCase в snake_case
function toSnakeCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(toSnakeCase);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc: any, key: string) => {
            const snakeKey = key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
            acc[snakeKey] = toSnakeCase(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}

export function logSigningEvent(data: SigningEventData) {
    // const currentTime = Date.now();
    
    // // Фильтруем системные поля по роли
    // const filteredEntities = filterSystemEntitiesByRole(data.visibleSystemEntities, data.role);
    
    // // Конвертируем время в секунды
    // data.timeFromStart = (currentTime - pageLoadTime) / 1000;
    // data.timeFromLastEvent = (currentTime - lastEventTime) / 1000;
    // data.visibleSystemEntities = filteredEntities;
    
    // // Преобразуем в snake_case при отправке
    // httpClient.post('/log-frontend-event', toSnakeCase(data))
    // .catch(error => {
    //     console.error('Ошибка при логировании события подписания:', error);
    // });
    
    // // Обновляем время последнего события
    // lastEventTime = currentTime;
}

export function logPerformanceEvent(data: PerformanceEventData) {
    // Преобразуем в snake_case при отправке
    // httpClient.post('/log-frontend-event', toSnakeCase(data))
    // .catch(error => {
    //     console.error('Ошибка при логировании метрик производительности:', error);
    // });
}

export function logPhotoProcessingEvent(data: PhotoProcessingEventData) {
    // Преобразуем в snake_case при отправке
    // httpClient.post('/log-frontend-event', toSnakeCase(data))
    // .catch(error => {
    //     console.error('Ошибка при логировании события обработки фото:', error);
    // });
} 